import React from "react";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./AppRoutes";
import "./assets/css/bootstrap.min.css";
import "./assets/css/tailwind.css";
import AuthScreen from "./components/Auth/AuthScreen";
import SubscriptionRequiredScreen from "./components/Auth/SubscriptionRequiredScreen";
import { useAuth } from "./context/AuthContext";

const App: React.FC = () => {
  const { currentUser, subscriptionRequired, loading } = useAuth();

  console.log({ currentUser, subscriptionRequired, loading });

  if (loading) {
    return <div>Loading...</div>;
  }
  if (subscriptionRequired) {
    return <SubscriptionRequiredScreen />;
  }

  if (!currentUser) {
    return <AuthScreen />;
  }

  return <AppRoutes />;
};

export default App;
